import "./jquery.cycle2.min.js";
import "./jquery.cycle2.carousel.min.js";
import $ from 'jquery';
window.addEventListener('px-ready',function(){
    $('.px-cycle-slideshow').cycle();
    $(window).on('resize',function(){
        //console.log('resize')
        var slideamount = 4;
        var width = $(window).width();
        if(width < 1400){
            slideamount = 3;
        }
        if(width < 1024){
            slideamount = 2;
        }
        if(width < 768){
            slideamount = 1;
        }
        var prevvisible = $('.px-cycle-slideshow').attr('data-cycle-carousel-visible');
        if(prevvisible != slideamount){
            //console.log('slideshow change')
            $('.px-cycle-slideshow').attr('data-cycle-carousel-visible',slideamount);
            $('.px-cycle-slideshow').cycle('reinit');
        }else{
            //console.log(slideamount);
        }
    }).trigger('resize');
})